import { setLocale } from 'yup'
import 'antd/dist/antd.css'

import 'src/services/api/index'

import './i18n'

export { default as GlobalStyle } from './global-styles'
export { default as Routes } from './routes'

// use constant translation keys for messages without values
setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  },
  number: {
    lessThan: 'common.required',
    max: 'common.required',
    min: 'common.required',
    moreThan: 'common.required'
  }
})
